<main>
  <section
    style="
      background-image: url('assets/images/forms-hero.jpg');
      background-size: cover;
      background-position: center;
    "
  >
    <div class="container px-4 py-5">
      <div class="row align-items-start g-lg-5 py-5">
        <div class="col-lg-10 text-lg-start text-light">
          <h1 class="display-4 lh-1 mb-3 py-4">Forms</h1>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-secondary mb-5">
    <div class="container py-5">
      <div class="row px-4 py-4 text-center">
        <p class="display-5 mb-4">Apply For Coverage</p>
        <div class="row row-cols-1 flex-md-equal w-100">
          <span>
            <button
              class="btn btn-primary px-4 gap-3"
              (click)="downloadForm('Irrigation Replacement Cost Form.pdf')"
            >
              Replacement Cost
            </button>
            <p class="fs-5 mb-4">
              Available for equipment 0-34 years.&nbsp;
            </p>
          </span>
          <span>
            <button
              class="btn btn-primary px-4 gap-3"
              (click)="downloadForm('Stated Value form.pdf')"
            >
              Stated Value
            </button>
            <p class="fs-5 mb-4">
              Available for equipment 35 years or greater or items with
              underslung pipe.
            </p>
          </span>
        </div>
      </div>
    </div>
  </section>

  <div class="container px-4" id="claimForms">
    <div class="row px-4 py-4 text-center">
      <p class="display-5 mb-4">Claim Forms</p>
      <div class="col-lg-10 mx-auto">
        <p class="fs-5 mb-4">
          Download, fill out and then follow the instructions for submission on
          each form.
        </p>
      </div>
    </div>
    <div class="row g-4 row-cols-1 row-cols-md-3">
      <div class="col hover-shadow" *ngFor="let form of claimForms">
        <a
          href="javascript:void(0)"
          (click)="downloadForm(form)"
          class="text-dark text-decoration-none"
        >
          <div
            class="d-flex flex-column feature border border-2 border-primary py-5 px-4 h-100"
          >
            <div class="feature-icon mt-3">
              <img src="assets/images/download-icon.svg" alt="Download" />
            </div>
            <h4 class="my-4">{{ getDisplayName(form) }}</h4>
          </div>
        </a>
      </div>
    </div>
  </div>

  <div class="container-fluid bg-secondary px-5 mb-5" style="margin-top: 100px">
    <div class="row justify-content-center">
      <div class="px-4 py-4 my-5 text-center">
        <p class="display-5 mb-4">Already filed a claim?</p>
        <div class="col-lg-11 mx-auto">
          <p class="fs-5 mb-4">Log in to track and manage your claims.</p>
          <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
            <a class="btn btn-primary px-4 gap-3" routerLink="/login">Login</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
